<!-- Notes -->
<div *ngIf="notes.length" class="!py-4 rounded-lg border border-palette-gray-200 bg-white !mb-2">
    <h3 class="text-lg text-palette-gray-900 font-semibold !p-4 !pt-0">{{ "MY_BOOKING.ORDER_NOTES" | translate }}</h3>
    <div class="flex flex-col !gap-3 !px-4 max-h-[164px] overflow-y-auto custom-scrollbar">
        <div *ngFor="let item of notes" class="rounded-lg bg-palette-amber-50 !px-4 !py-3">
            <p class="text-sm text-palette-gray-900 !mb-3 break-all">{{ item.note }}</p>
            <div class="flex justify-between items-center !gap-1 flex-wrap">
                <div class="flex items-center !gap-[6px]">
                    <img src="assets\images\logo\blue-logo.svg" alt="Avatar" class="!w-5 !h-5 min-h-5 aspect-square rounded-full object-cover">
                    <p class="text-xs font-medium text-palette-gray-500">
                        {{ 'COMMON.CSKH' | translate }}
                    </p>
                </div>
                <p class="text-xs font-medium text-palette-gray-500 whitespace-nowrap">
                    {{(item?.created_at | dateFormat: false : false: 'HH:mm' ) + ', ' +
                    (item?.created_at | dateFormat ) + ' ' + getUTCUser() }} </p>
            </div>
        </div>
    </div>
</div>
